<!--
  Status chip for registrations: a tinted pill the size of a control,
  coloured by tone — ok (paid, registered), warn (payment open), crit (full,
  cancelled), neutral (waitlist, comp, refunded). It reads the same size
  tokens as the fields and buttons around it, so it stands level with them.
-->
<script>
  let {
    /** 'ok' | 'warn' | 'crit' | 'neutral' */
    tone = 'neutral',
    class: css_class = '',
    children,
  } = $props();
</script>

<span class='event-chip text-control {tone} {css_class}'>{@render children()}</span>

<style lang='postcss'>
  .event-chip {
    display: inline-flex;
    align-items: center;
    min-height: var(--input-min-height);
    padding-inline: var(--input-inline-spacing);
    padding-block: var(--input-block-spacing);
    border-radius: var(--input-border-radius);
    /* Between the label and a spinner standing before it */
    column-gap: var(--size-2);
    white-space: nowrap;
    color: var(--chip-color);
    background-color: var(--chip-background);
    /* Readable on light and dark grounds: the hue's lightness follows the site's lux mode */
    --chip-lightness: calc(0.5 + (1 - var(--color-default-background-lux-mode)) * 0.15);
  }
  .neutral {
    --chip-color: var(--text-2);
    --chip-background: var(--color-default-background-50);
  }
  .ok {
    --chip-color: oklch(from var(--color-positive) var(--chip-lightness) c h);
    --chip-background: oklch(from var(--color-positive) l c h / 0.14);
  }
  .warn {
    --chip-color: oklch(from var(--color-warning) var(--chip-lightness) c h);
    --chip-background: var(--color-warning-bg);
  }
  .crit {
    --chip-color: oklch(from var(--color-destructive) var(--chip-lightness) c h);
    --chip-background: oklch(from var(--color-destructive) l c h / 0.12);
  }
  /* The shared spinner (animations.css) in the chip's own colour */
  .event-chip :global(.loading-spinner) {
    border-color: color-mix(in oklch, currentColor 30%, transparent);
    border-top-color: currentColor;
  }
</style>
